// src/features/tasks/components/TaskListPage/TasksDataGrid/components/StateCell.jsx
import React from 'react';
import { Stack, Box, Chip, LinearProgress } from '@mui/material';
import {
  getStateConfig,
  isTaskOverdue,
} from '../../../../utils/taskStateUtils';

export default function StateCell({ value, row }) {
  const stateConfig = getStateConfig(value);
  const StateIcon = stateConfig.icon;
  const isOverdue = isTaskOverdue(row);

  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ width: '100%' }}>
      <Box>
        <Chip
          icon={<StateIcon />}
          label={stateConfig.label}
          size="small"
          color={isOverdue ? 'error' : stateConfig.color}
          variant={isOverdue ? 'filled' : 'outlined'}
          sx={isOverdue ? { 
            animation: 'pulse 2s infinite',
            '@keyframes pulse': {
              '0%': { opacity: 1 },
              '50%': { opacity: 0.7 },
              '100%': { opacity: 1 },
            }
          } : {}}
        />
      </Box>
    </Stack>
  );
}